import { PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import { beginLoading, endLoading } from "./loadingSpinner";
import { createErrorMessages, createBackendErrorMessages, messagesReceived } from "./message";

import { CURRENT_USERNAME_IS_VALID } from "./userManagement";
import { LOAD_SUCCESSFUL_ACTION } from "./survey";
import rest from "../common/rest";

const CHANGE_PROPERTY_ACTION = "MANAGE_SURVEY_TEMP_USERS.CHANGE_PROPERTY_ACTION";
const LOAD_LIST_SUCCESSFUL_ACTION = "MANAGE_SURVEY_TEMP_USERS.LOAD_LIST_SUCCESSFUL_ACTION";
const COPY_DATA_ACTION = "MANAGE_SURVEY_TEMP_USERS.COPY_DATA_ACTION";
const USERNAME_IS_VALID_ACTION = "MANAGE_SURVEY_TEMP_USERS.USERNAME_IS_VALID_ACTION";
const PREPARE_DATA_FOR_SHOW_LINK_ACTION = "MANAGE_SURVEY_TEMP_USERS.PREPARE_DATA_FOR_SHOW_LINK_ACTION";

export const SHOW_TEMP_USER_DIALOG = "showTempUserDialog";
export const EDIT_TEMP_USER_DIALOG = "editTempUserDialog";
export const TEMP_USER_LIST = "tempUserList";
export const TEMPORARY_USER = "temporaryUser";
export const TEMPORARY_USER_ID = "temporaryUserId";
export const TEMPORARY_USER_USERNAME = "temporaryUserUsername";
export const SHOW_INACTIVE_RESPONDENTS = "showInactiveRespondents";
export const FIRSTNAME = "firstname";
export const LASTNAME = "lastname";
export const FULLNAME = "fullName";
export const EMAIL = "email";
export const IDENTIFIER = "identifier";
export const USERNAME = "username";
export const USERNAME_ALREADY_EXISTS = "usernameAlreadyExists";
export const DATE_OF_VALIDITY = "dateOfValidity";
export const CREATE_NEW_TEMP_USER = "createNewTempUser";
export const DEACTIVATE_TEMP_USER = "deactivateTempUser";
export const SHOW_TEMP_USER_LINK = "showTempUserLink";
export const TEMP_USER_LINK = "tempUserLink";
export const IS_ACTIVE = "isActive";
const NUMBER_OF_MONTHS_TO_ADD = 3;

const initialState = {
  [SHOW_TEMP_USER_DIALOG]: false,
  [SHOW_INACTIVE_RESPONDENTS]: false,
  [EDIT_TEMP_USER_DIALOG]: false,
  [CREATE_NEW_TEMP_USER]: false,
  [DEACTIVATE_TEMP_USER]: false,
  [SHOW_TEMP_USER_LINK]: false,
  [TEMPORARY_USER_ID]: null,
  [TEMPORARY_USER_USERNAME]: "",
  [FIRSTNAME]: "",
  [LASTNAME]: "",
  [USERNAME]: "",
  [USERNAME_ALREADY_EXISTS]: false,
  [TEMP_USER_LINK]: "",
  [CURRENT_USERNAME_IS_VALID]: true
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case LOAD_SUCCESSFUL_ACTION:
      newState = Object.assign({}, state, initialState);
      break;
    case USERNAME_IS_VALID_ACTION:
      newState = Object.assign({}, state, {
        [CURRENT_USERNAME_IS_VALID]: action[CURRENT_USERNAME_IS_VALID]
      });
      break;
    case CHANGE_PROPERTY_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    case LOAD_LIST_SUCCESSFUL_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE],
        [CURRENT_USERNAME_IS_VALID]: true
      });
      break;
    case COPY_DATA_ACTION:
      newState = Object.assign({}, state, {
        [FIRSTNAME]: action[FIRSTNAME],
        [LASTNAME]: action[LASTNAME],
        [USERNAME]: action[USERNAME],
        [DATE_OF_VALIDITY]: action[DATE_OF_VALIDITY]
      });
      break;
    case PREPARE_DATA_FOR_SHOW_LINK_ACTION:
      newState = Object.assign({}, state, {
        [SHOW_TEMP_USER_LINK]: action[SHOW_TEMP_USER_LINK],
        [TEMPORARY_USER_ID]: action[TEMPORARY_USER_ID],
        [TEMPORARY_USER_USERNAME]: action[TEMPORARY_USER_USERNAME],
        [TEMP_USER_LINK]: action[TEMP_USER_LINK]
      });
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}

export function changeProperty(propertyName, propertyValue) {
  return (dispatch) => {
    if (propertyName === CREATE_NEW_TEMP_USER && propertyValue === true) {
      let d = new Date();
      d.setMonth(d.getMonth() + NUMBER_OF_MONTHS_TO_ADD);
      dispatch({
        [TYPE_KEY]: COPY_DATA_ACTION,
        [FIRSTNAME]: "",
        [LASTNAME]: "",
        [USERNAME]: "",
        [DATE_OF_VALIDITY]: d.toISOString()
      });
    }
    dispatch({
      [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
      [PROPERTY_NAME]: propertyName,
      [PROPERTY_VALUE]: propertyValue
    });
  };
}

export function changeTempUserProperty(propertyName, propertyValue) {
  return (dispatch) => {
    if (propertyName === USERNAME && propertyValue) {
      rest
        .doGet(`/authentication/users/search/findByUsername?username=${propertyValue}`)
        .then(() => dispatch(changeProperty(USERNAME_ALREADY_EXISTS, true)))
        .catch(() => dispatch(changeProperty(USERNAME_ALREADY_EXISTS, false)));
    }

    dispatch({
      [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
      [PROPERTY_NAME]: propertyName,
      [PROPERTY_VALUE]: propertyValue
    });
  };
}

// load temp survey users for server
export function loadTempUsers(unitForeignId) {
  return (dispatch, getState) => {
    dispatch(beginLoading());
    let showInactiveRespondents = getState().manageSurveyTempUsers.showInactiveRespondents;
    rest
      .doGet(`/authentication/temporaryusers?unitForeignId=${unitForeignId}&includeInactive=${showInactiveRespondents}`)
      .then(
        (json) => {
          if (json.temporaryUsers) {
            dispatch(loadSuccessful(TEMP_USER_LIST, json.temporaryUsers));
            dispatch(endLoading());
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
            dispatch(endLoading());
          }
        },
        (reason) => {
          dispatch(messagesReceived(createBackendErrorMessages(reason)));
          dispatch(endLoading());
        }
      );
  };
}

// deactivate temp survey user
export function deactivateTempUserAction(identifier, unitForeignId) {
  return (dispatch) => {
    dispatch(beginLoading());
    rest.doDelete(`/authentication/temporaryusers/${identifier}?unitForeignId=${unitForeignId}`).then(
      (json) => {
        if (json) {
          dispatch(loadTempUsers(unitForeignId));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

// load temp survey user
export function loadTempUser(identifier, unitForeignId) {
  return (dispatch) => {
    dispatch(beginLoading());
    rest.doGet(`/authentication/temporaryusers/${identifier}?unitForeignId=${unitForeignId}`).then(
      (json) => {
        if (json) {
          dispatch(copyData(json));
          dispatch(loadSuccessful(TEMPORARY_USER, json));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

// update temp survey user
export function updateTempUser(identifier, unitForeignId) {
  let d = new Date();
  d.setMonth(d.getMonth() + NUMBER_OF_MONTHS_TO_ADD);
  return (dispatch, getState) => {
    dispatch(beginLoading());
    let { firstname, lastname, username, dateOfValidity } = getState().manageSurveyTempUsers;
    let temporaryUser = {
      [FIRSTNAME]: firstname,
      [LASTNAME]: lastname,
      [USERNAME]: username,
      [IDENTIFIER]: identifier,
      [IS_ACTIVE]: true,
      [DATE_OF_VALIDITY]: dateOfValidity
        ? typeof dateOfValidity === "string"
          ? dateOfValidity.substr(0, 10)
          : dateOfValidity.toISOString().substr(0, 10)
        : d.toISOString().substr(0, 10)
    };

    rest
      .doPut(
        `/authentication/temporaryusers/${identifier}?unitForeignId=${unitForeignId}`,
        JSON.stringify(temporaryUser)
      )
      .then(
        (json) => {
          if (json) {
            dispatch(loadTempUsers(unitForeignId));
            dispatch(endLoading());
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
            dispatch(endLoading());
          }
        },
        (reason) => {
          dispatch(messagesReceived(createBackendErrorMessages(reason)));
          dispatch(endLoading());
        }
      );
  };
}

export function checkUsername(username) {
  let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  let valid = re.test(username);
  return {
    [TYPE_KEY]: USERNAME_IS_VALID_ACTION,
    [CURRENT_USERNAME_IS_VALID]: valid
  };
}

export function createNewRespondent(unitForeignId, propertyName, propertyValue) {
  return (dispatch, getState) => {
    dispatch(beginLoading());
    let { firstname, lastname, username, dateOfValidity } = getState().manageSurveyTempUsers;
    dispatch(checkUsername(username));
    if (getState().manageSurveyTempUsers[CURRENT_USERNAME_IS_VALID]) {
      let temporaryUser = {
        [FIRSTNAME]: firstname,
        [LASTNAME]: lastname,
        [USERNAME]: username.toLowerCase(),
        [DATE_OF_VALIDITY]: dateOfValidity
          ? typeof dateOfValidity === "string"
            ? dateOfValidity.substr(0, 10)
            : dateOfValidity.toISOString().substr(0, 10)
          : null
      };

      rest.doPost(`/authentication/temporaryusers?unitForeignId=${unitForeignId}`, JSON.stringify(temporaryUser)).then(
        (json) => {
          if (json) {
            dispatch(createNewSurveyRespondent(json, unitForeignId));
            dispatch(loadTempUsers(unitForeignId));
            dispatch(prepareDataForTempUserLink(json));
            dispatch(endLoading());
            dispatch({
              [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
              [PROPERTY_NAME]: propertyName,
              [PROPERTY_VALUE]: propertyValue
            });
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
            dispatch(endLoading());
          }
        },
        (reason) => {
          dispatch(messagesReceived(createErrorMessages("temporary.user.create.error")));
          dispatch(endLoading());
        }
      );
    } else {
      dispatch(endLoading());
    }
  };
}

export function createNewSurveyRespondent(tempUser, unitForeignId) {
  return (dispatch) => {
    dispatch(beginLoading());
    dispatch(checkUsername());

    let temporaryUser = {
      [FULLNAME]: tempUser[FIRSTNAME] + " " + tempUser[LASTNAME],
      [USERNAME]: tempUser[USERNAME],
      [EMAIL]: tempUser[USERNAME]
    };

    rest.doPost(`/survey/surveys/overviews/${unitForeignId}/respondents`, JSON.stringify(temporaryUser)).then(
      (json) => {
        if (json) {
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createErrorMessages("temporary.user.create.error")));
        dispatch(endLoading());
      }
    );
  };
}

export function loadSuccessful(propertyName, json) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: LOAD_LIST_SUCCESSFUL_ACTION,
      [PROPERTY_NAME]: propertyName,
      [PROPERTY_VALUE]: json
    });
  };
}

export function prepareDataForTempUserLink(json) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: PREPARE_DATA_FOR_SHOW_LINK_ACTION,
      [SHOW_TEMP_USER_LINK]: true,
      [TEMPORARY_USER_ID]: json.identifier,
      [TEMPORARY_USER_USERNAME]: json.username,
      [TEMP_USER_LINK]: window.location.protocol + "//" + window.location.host + `/?jwt=` + json.jwt
    });
  };
}

export function copyData(json) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: COPY_DATA_ACTION,
      [FIRSTNAME]: json[FIRSTNAME],
      [LASTNAME]: json[LASTNAME],
      [USERNAME]: json[USERNAME],
      [DATE_OF_VALIDITY]: json[DATE_OF_VALIDITY]
    });
  };
}

// get temp user link
export function getTempUserLink(tempUserList, identifier) {
  let jwt = "";
  for (let i = 0; i < tempUserList.length; i++) {
    if (tempUserList[i].identifier === identifier) {
      jwt = tempUserList[i].jwt;
    }
  }
  return (dispatch) => {
    dispatch(changeProperty("tempUserLink", window.location.protocol + "//" + window.location.host + `/?jwt=` + jwt));
  };
}
